module.exports = __webpack_public_path__ + "static/media/СЗФО_2019.e155ee49.png";